import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    FormGroup,
    Label,
    Row,
    Col,
    Input,
    InputGroup,
    InputGroupText,
} from 'reactstrap';
import * as Yup from 'yup';
import moment from 'moment';
import { Formik, Field } from 'formik';
import { cloneDeep, find } from 'lodash';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { default as ReactSelect } from "react-select";
import Inficon from 'assets/icon/Inficon.svg'
import Tooltip from 'react-tooltip-lite';
import { Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import ReactInputMask from 'react-input-mask';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
// import search from 'assets/icon/search.svg';
// import reset from "assets/icon/resetIcon.png";
// import search from "assets/icon/searchIcon.png";
import resetIcon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";



let hasDatePopupOpen = false;
let pharmacyData = [];
let claimTypesData = [];
let pharmacyError = "Please Select Pharmacy";

const validationSchema = Yup.object({
    //coveredEntityID: Yup.string().required('Please select covered entity'),
});

const SearchContainer = (props) => {
    const API = useAxios();
    const {
        states: { pharmacyreports },
        setStates,
        resetStates,
    } = useContextService();

    const { orgId, GetNPIFunction, defaultPharmacyFilter, tenantID } = props;
    const { onSearch, onReset } = props;
    const formikRef = useRef();

    const [hasPHselected, setPHselected] = useState(true);
    const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
    const [isSubmited, setIsSubmitted] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isStartDate, setIsStartDate] = useState(null);
    const [isEndDate, setIsEndDate] = useState(null);
    const [dateRangeValue, setDateRangeValue] = useState(1);
    const [err, setError] = useState('');
    const [claimTypesList, setClaimTypes] = useState([]);
    const [selectedClaimType, setClaimTypeSelected] = useState("");
    const [key, setKey] = useState('PharmacySummary');
    const { searchTerms, pharmacy } = pharmacyreports

    // const searchTerms = pharmacyreports?.searchTerms;

    let {
        startDate,
        endDate,
        claimTypeId,
        pharmacyId
    } = searchTerms;

    const dateRangeOption = [
        { id: '2', label: 'Last Month' },
        { id: '3', label: 'Last 30 Days' },
        { id: '4', label: 'Last 90 Days' },
        { id: '5', label: 'Last 180 Days' },
        { id: '6', label: 'Last 365 Days' },
        { id: '7', label: 'Custom' }
    ];

    const claimTypeOptions = [
        { id: '0', description: 'All' },
        { id: '9002', description: 'Captured Claims' },
        { id: '9003', description: 'Non-Captured Claims' },
        { id: '370007', description: 'Non-Derived Claims' }
    ]

    const DateRangeTypeList = [{ code: 'Current Month', RangeTypeList: 'Current Month', Id: 1 }, { code: 'Last Month', RangeTypeList: 'Last Month', Id: 2 }, { code: 'Last 30 Days', RangeTypeList: 'Last 30 Days', Id: 3 }, { code: 'Last 90 Days', RangeTypeList: 'Last 90 Days', Id: 4 }, { code: 'Last 180 Days', RangeTypeList: 'Last 180 Days', Id: 5 }, { code: 'Last 365 Days', RangeTypeList: 'Last 365 Days', Id: 6 }, { code: 'Custom', RangeTypeList: 'Custom', Id: 7 }];
    const claimTypeOpt = [{ Code: 'All', ClaimType: 'All', id: 0 }, { Code: 'Captured Claims', ClaimType: 'Captured Claims', Id: 9002 }, { Code: 'Non-Captured Claims', ClaimType: 'Non-Captured Claims', Id: 9003 }, { Code: 'Non-Derived Claims', ClaimType: 'Non-Derived Claims', Id: 370007 }];


    useEffect(() => {     
        setPHselected(true);
        pharmacyreports.pharmacyData = [];
        setOptionSelected({ optionSelected: '-1' });
        setDateRangeValue(1);
        setClaimTypeSelected('');
        setDateRangeValue(1);
        fetchPharmacy();      
    }, [orgId]);

    useEffect(() => {        
        fetchClaimTypes();       
    }, [])

    const updateStates = (pharmacyreports) => {
        setStates('pharmacyreports', pharmacyreports);
    };

    const fetchPharmacy = async () => {        
         pharmacyData = [];
        try {

            const { data } = await API.get(`CPConfig/ColumnSelector/pharmacieslist`, {
                hasDefaultURL: true,
            });            
            if (data) {
                if(pharmacyData.length == 0 ){
                    for (var x in data) {
                        pharmacyData.push({ "value": data[x].pharmacyID, "label": data[x].pharmacyName, "encryptedNPI": data[x].encryptedNPI });
    
                    }
                }                
                // pharmacyIDs.pharmacyData = data;

                // pharmacyIDs.pharmacyData = tenantId;
                updateStates(pharmacyreports)
                if (pharmacyId) {

                    var pharmacySelected = {};
                    pharmacySelected.optionSelected = [];
                    for (var x in pharmacyId) {
                        pharmacySelected.optionSelected.push(pharmacyId[x]);
                    }
                    setOptionSelected({ optionSelected: '-1' });
                }
            }

        } catch (err) {

        }
    };

    const handlePharmacyChange = (selected, setFieldValue, value) => {
        debugger;        
        if (selected) {
            setPHselected(true);
            // setTenantId(selected.tenantID)
            setOptionSelected({
                optionSelected: selected
            });
            let isDisabled = value == "" ? true : false;
            setFieldValue("pharmacyId", selected);
            setSubmit(isDisabled);
            GetNPIFunction(pharmacyData.filter(c => c.encryptedNPI == selected.encryptedNPI)[0]);
            let phID = [];
            for (var x in selected) {
                var rw = selected[x];
                phID.push(rw.value);
            }
            pharmacyreports.searchTerms.pharmacyId = selected.value;
            updateStates(pharmacyreports);
        }
        else {
            setFieldValue('pharmacyId', {});
            setClaimTypeSelected('');
            setPHselected(false);          
        }

    };
    const handleDateRangeChange = ({ target: { value } }, setFieldValue) => {
        
        if (value) {
            const statusID = parseInt(value) - 1;
            const findObj = DateRangeTypeList[statusID];
            setFieldValue('dateRange', value)
            pharmacyreports.dateRange = findObj.Id;
            pharmacyreports.dateRangeID = findObj.Id;
            setDateRangeValue(findObj.Id);
            setIsStartDate(null);
            setIsEndDate(null);
            setError('');
            pharmacyreports.searchTerms.dateRangeID = findObj.Id;
            pharmacyreports.searchTerms.isStartDate = '';
            pharmacyreports.searchTerms.isEndDate = '';
            setFieldValue('isStartDate', '');
            setFieldValue('isEndDate', '');
            updateStates(pharmacyreports);
        } else {
            setFieldValue('dateRange', '')
            pharmacyreports.dateRange = {};
            pharmacyreports.dateRangeID = null;
            setDateRangeValue(1);
            setError('');

        }
    }

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleStartDate = (startDate) => {
        
        setError('');
        let stDate = dateFormate(startDate);
        setIsStartDate(stDate);
        pharmacyreports.searchTerms.startDate = moment(new Date(startDate)).format(
            'MM/DD/YYYY'
        );
    };

    const handleEndDate = (endDate) => {
        
        let enDate = dateFormate(endDate);
        setIsEndDate(enDate);
        pharmacyreports.searchTerms.endDate = moment(new Date(endDate)).format(
            'MM/DD/YYYY'
        );
    };

    const handleStartDateRaw = (e) => {
        
        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        if (isValid == false && pharmacyreports.searchTerms.startDate !== null && val == '__/__/____') {
            pharmacyreports.searchTerms.startDate = null;
            setIsStartDate(null);
            updateStates(pharmacyreports);

        }

        if (isValid) {
            const newDate = new Date(e.target.value);
            handleStartDate(newDate);
        }
    }

    const handleEndDateRaw = (e) => {
        
        var valdt = new Date(endDate)
        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        if (isValid == false && pharmacyreports.searchTerms.endDate !== null && val == '__/__/____') {
            pharmacyreports.searchTerms.endDate = null;
            setIsEndDate(null)
            updateStates(pharmacyreports);
        }

        if (isValid && val >= valdt) {
            const newDate = new Date(e.target.value);
            handleEndDate(newDate);
        }
    }

    const handleSubmit = async (value, actions,) => {
        
        setIsSubmitted(true);
        const { setSubmitting } = actions;
        let phID = value.pharmacyId;
        if (phID.value == undefined) {
            setPHselected(false);
            setSubmitting(false);
        }
        const values = cloneDeep(value);
        values.pharmacyId = phID.value;

        if (startDate) values.startDate = startDate;
        if ((startDate == null || startDate == "") && pharmacyreports.dateRange == 7) {
            return setError('Start date is required')
        }
        if (endDate) values.endDate = endDate;
        if (phID.value) {
            values.pharmacyId = phID.value;
            setSubmit(true);
        }
        values.claimTypeId = selectedClaimType ? selectedClaimType : "0";
        values.dateRangeID = dateRangeValue;
        setKey('PharmacySummary');
        pharmacyreports.search.currentPage = 1;
        updateStates(pharmacyreports);
        await onSearch(values);
        setSubmitting(false);

    };

    const fetchClaimTypes = async () => {
        
        try {
            const { data } = await API.get(`CPConfig/ColumnSelector/ClaimTypes`, {
                hasDefaultURL: true,
            });
            if (data) {
                claimTypesData = data;
                if (claimTypeId) {
                    pharmacyreports.searchTerms.claimStatusId = claimTypeId;
                    updateStates(pharmacyreports);
                }
                setClaimTypes(data);
            } else {
                setClaimTypes([]);
            }
        } catch (err) { }
    };

    const handleClaimTypeChange = (e, setFieldValue) => {
        const { value } = e.target;
        setFieldValue('claimTypeId', value);
        setClaimTypeSelected(value);
        pharmacyreports.searchTerms.claimTypeId = value;
        updateStates(pharmacyreports);
    };


    const handelReset = ({ resetForm }) => {
        
        setIsSubmitted(false);
        setPHselected(true);
        setIsStartDate(null);
        setIsEndDate(null);
        setError('');
        setClaimTypeSelected('');
        window.selectedOption = "";
        onReset();
        pharmacyreports.searchTerms.pharmacyId = [];
        pharmacyreports.search = cloneDeep(defaultPharmacyFilter);
        resetForm();
        setDateRangeValue(1);

        // pharmacyreports.pharmacyData = [];
        // pharmacyreports.pharmacies = [];
        // pharmacyreports.dateRange = [];
        setOptionSelected({ optionSelected: '-1' });
        updateStates(pharmacyreports);
        resetStates('pharmacyreports');
    }

    return (
        <Formik
            innerRef={formikRef}
            onSubmit={handleSubmit}
            initialValues={searchTerms}
            validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
                const { handleSubmit, resetForm, setFieldValue } = props;
                return (
                    <div>
                        <div className='d-flex justify-content-between'>
                            <h5 className='f-16 text-primary font-weight-700'>
                                Search Pharmacy Reports
                            </h5>

                            <Tooltip content={(<div className='tip-list-info'
                                height={70}
                                width={500}
                            >
                                <p>
                                    Captured Claims: Claims that have been captured successfully captured and with in the system.
                                </p>
                                <p>
                                    Non-Captured Claims: Claims that have not been successfully captured and remain unprocessed.
                                </p>
                                <p>
                                    Non-Entity Derived Claims: Claims where the client or covered entity cannot be determined.
                                </p>
                            </div>)} direction='left'>
                                <img src={Inficon} alt='' style={{ marginLeft: 0 }} />
                            </Tooltip>
                        </div>

                        <Row sm={5} >
                            <Col md={3} sm={3} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='pharmacyId'>Pharmacy</Label>
                                    <ReactSelect
                                        name='pharmacyId'
                                        id='pharmacyId'
                                        options={pharmacyData}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        optionSelected={true}
                                        components={{
                                            Option
                                        }}
                                        isSearchable="true"
                                        onChange={(value, phcy) =>
                                            handlePharmacyChange(value, setFieldValue, phcy)
                                        }
                                        value={selectedOption.optionSelected}
                                        className='claim_info required'
                                        maxMenuHeight={220}
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 99,
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                            })
                                        }}
                                    />
                                    {(!hasPHselected) ? (
                                        <div className="text-danger f-12 position-absolute">
                                            {pharmacyError}
                                        </div>
                                    ) : null}
                                </FormGroup>
                            </Col>

                            <Col md={3} sm={3} xs={6}>
                                <FormGroup>
                                    <Label for='claimType'>Claim Type</Label>
                                    <Field
                                        name='claimType'
                                        type='text'
                                        autoComplete="off"
                                        value={selectedClaimType}
                                        onChange={(val) => handleClaimTypeChange(val, setFieldValue)}
                                        component={FormikSelectField}
                                        options={claimTypesData}
                                        defaultoption='--All--'
                                        defaultValue={claimTypeOpt[0]}
                                        keys={{
                                            id: 'id',
                                            label: 'description',
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={3} sm={3} xs={6}>

                                {' '}
                                <FormGroup>
                                    <Label for="dateRange">Date Range</Label>
                                    <Field
                                        id="dateRange"
                                        name="dateRange"
                                        className="requiredS"
                                        type="text"
                                        component={FormikSelectField}
                                        options={dateRangeOption}
                                        value={dateRangeValue}
                                        onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                                        defaultoption='Current Month'
                                        defaultValue={1}
                                        keys={{
                                            id: "id",
                                            label: "label",
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={3} sm={6}>
                                <Row>
                                    <Col className='required-date'>
                                        <FormGroup hidden={dateRangeValue != '7'}>
                                            <Label>Start Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <DatePicker
                                                    id='isStartDate'
                                                    name='isStartDate'
                                                    selected={startDate}
                                                    onChange={(e) => { handleStartDate(e) }}
                                                    onChangeRaw={handleStartDateRaw}
                                                    dateFormat="MM/dd/yyyy"
                                                    portalId="root portal"
                                                    placeholderText='Select a date'
                                                    autoComplete='off'
                                                    customInput={
                                                        <ReactInputMask mask="99/99/9999"
                                                            value={isStartDate}
                                                        // maskChar=''
                                                        />
                                                    }
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('isStartDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                        {err && <div className="text-danger font-size-12" >{err}</div>}

                                    </Col>

                                    <Col xs='auto' className='pt-3 mt-3'>
                                        <Label className='mt-1' hidden={dateRangeValue != '7'}>-</Label>
                                    </Col>
                                    <Col className='purchase-date'>
                                        <FormGroup hidden={dateRangeValue != '7'}>
                                            <Label>End Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <DatePicker
                                                    id='endDate'
                                                    name='endDate'
                                                    selected={endDate}
                                                    onChange={(e) => { handleEndDate(e) }}
                                                    onChangeRaw={handleEndDateRaw}
                                                    dateFormat="MM/dd/yyyy"
                                                    portalId="root portal"
                                                    placeholderText='Select a date'
                                                    autoComplete='off'
                                                    minDate={new Date(startDate)}
                                                    customInput={
                                                        <ReactInputMask mask="99/99/9999"
                                                            value={endDate}
                                                        // maskChar=''
                                                        />
                                                    }
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('endDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>





                        </Row>
                        <Row className='d-flex' style={{ justifyContent: "flex-end" }}>
                            <Col md='auto' className=''  >
                                <Label>{''}</Label>
                                <Button
                                    // disabled={isSubmitting}
                                    // setIsSubmitted={true}
                                    onClick={handleSubmit}
                                    color='primary'
                                    className='ms-3 search'
                                >
                                    <span className='right_5'><img src={search} alt="" /></span> Search
                                </Button>
                                <Button color='primary'
                                    className='reset'
                                    onClick={() => handelReset(props)}
                                >
                                    <span className="right_5">
                                        <img src={resetIcon} alt="" />
                                    </span>{" "}
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </div>
                );
            }}
        ></Formik>
    );
};

export default SearchContainer;
